import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'PREALERT 変更履歴',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: false,
};
